import React from "react";
import { Input, Label, makeStyles } from "@fluentui/react-components";
import { themeTokens } from "../../../../utils/Theming";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    marginBottom: themeTokens.spacingVerticalMNudge,
  },
  label: {
    width: "10%",
  },
  input: {
    width: "90%",
    "& input": {
      cursor: "default",
      backgroundColor: "transparent",
    },
    "&::after": {
      display: "none",
    }
  },
});

type PhoneEntry = {
  type: string;
  phoneNumber: string;
};

type PhoneValue = string | Record<string, PhoneEntry>;

const PhoneReadOnlyField = ({ value, icon }: { value: PhoneValue; icon?: React.ReactNode }) => {
  const styles = useStyles();

  const processValue = (val: PhoneValue): string => {
    if (!val) return "";

    if (typeof val === "object" && val !== null) {
      const phoneNumbers = Object.values(val).filter(
        (entry): entry is PhoneEntry => entry.phoneNumber && entry.phoneNumber.trim() !== ""
      );

      const priorityOrder = ["primary", "mobile", "work", "other"];
      for (const type of priorityOrder) {
        const matchingPhone = phoneNumbers.find((phone) => phone.type === type);
        if (matchingPhone) {
          return matchingPhone.phoneNumber.trim();
        }
      }
      return "";
    }

    return typeof val === "string" && val.trim() !== "null" ? val.trim() : "";
  };

  const displayValue = processValue(value);

  return (
    <div className={styles.container}>
      {icon && <Label className={styles.label}>{icon}</Label>}
      <Input className={styles.input} value={displayValue} readOnly />
    </div>
  );
};

export default PhoneReadOnlyField;
